import { useTokenizedApi } from '../useTokenizedApi';
import { useQuery } from 'react-query';

/** @category Logging in and Security */
export function useUserDetails() {
  const tokenizedApi = useTokenizedApi();
  // Special case: in the mobile app after rejecting a scanned QR code,
  // tokenizedApi can be null with this hook active, so handle that
  // without throwing an error
  const user = useQuery(tokenizedApi?.account.userDetailsQuery());
  return user?.data;
}
